import { useAdminStore } from '@admin/AppProvider'
import { Box, Container } from '@mui/material'
import { Loader, useMinimalsTheme } from '@tom-ui/ui'
import { authStore, useAsyncFetch, withAuthenticationRequired } from '@tom-ui/utils'
import { observer } from 'mobx-react-lite'
import { UsersHeader } from './components/molecules/UsersHeader'
import { UsersTable } from './components/organisms/UsersTable'

export const UsersTablePage = withAuthenticationRequired(
  observer(() => {
    const theme = useMinimalsTheme()
    const { userStore, tenantStore } = useAdminStore()

    const { loading } = useAsyncFetch(async () => {
      if (authStore.isSuperUser) await tenantStore.load()

      await userStore.load()
    }, [userStore, tenantStore])

    if (loading) return <Loader show />

    return (
      <Box sx={{ bgcolor: theme.palette.grey[100], minHeight: '100%' }}>
        <UsersHeader />
        <Container sx={{ paddingY: theme.customSpacing.m }}>
          <UsersTable store={userStore} tenants={tenantStore.items} />
        </Container>
      </Box>
    )
  }),
)
